import { Controller } from "@hotwired/stimulus"

const MODES = ["horizontal", "vertical", "aesthetic"]
const MODE_KEY = "thuvien.ui.palette-mode"

// Shows the palette in a modal dialog that fills the browser window (like Coolors), not the whole screen.
export default class extends Controller {
  static targets = ["dialog", "stage", "modeButton", "motif"]

  disconnect() {
    this.close()
  }

  open() {
    this.show(this.savedMode() || (matchMedia("(orientation: portrait)").matches ? "vertical" : "horizontal"))
    this.dialogTarget.showModal()
  }

  // From the style gallery: open straight into one aesthetic motif without changing the saved mode.
  openMotif({ params: { motif } }) {
    this.motifTargets.forEach((svg) => svg.toggleAttribute("hidden", svg.dataset.motif !== motif))
    this.show("aesthetic")
    this.dialogTarget.showModal()
  }

  close() {
    if (this.hasDialogTarget && this.dialogTarget.open) this.dialogTarget.close()
  }

  mode(event) {
    this.show(event.currentTarget.dataset.mode)
    try { localStorage.setItem(MODE_KEY, this.stageTarget.dataset.mode) } catch (_) { /* Optional preference. */ }
  }

  nextMotif() {
    // Motifs are <svg> elements, which have no `hidden` property, so toggle the attribute.
    const current = this.motifTargets.findIndex((motif) => !motif.hasAttribute("hidden"))
    this.motifTargets.forEach((motif, index) => motif.toggleAttribute("hidden", index !== (current + 1) % this.motifTargets.length))
  }

  show(mode) {
    this.stageTarget.dataset.mode = mode
    this.modeButtonTargets.forEach((button) => button.setAttribute("aria-pressed", String(button.dataset.mode === mode)))
  }

  savedMode() {
    try {
      const mode = localStorage.getItem(MODE_KEY)
      return MODES.includes(mode) ? mode : null
    } catch (_) { return null }
  }
}
